import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FiArrowRight } from 'react-icons/fi';
import { cloudinaryImage } from '../utils/images';

import './ServicesSection.css'; 
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import LoadingSpinner from './LoadingSpinner'; // En üste ekle
import CountUp from './reactbit/CountUp';
import StarBorder from './reactbit/StarBorder';


const API_BASE_URL = (process.env.REACT_APP_API_URL).replace(/\/$/, '');

const ServicesSection = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // DÜZELTİLMİŞ URL
        const apiUrl = `${API_BASE_URL}/api/services`;
        
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/services`);
        
        console.log('Backend response:', data);
        console.log('Data tipi:', typeof data);
        console.log('Array mi?', Array.isArray(data));
        
        if (Array.isArray(data)) {
          setServices(data);
        } else {
          console.error('Backend array döndürmedi:', data);
          setServices([]);
          setError('Hizmet verisi yanlış formatta');
        }
        
      } catch (err) {
        console.error("Hizmetler yüklenirken hata:", err);
        setError('Hizmetler yüklenemedi');
        setServices([]);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  return (
    <section className="services-section simple-section">
      <div className="container">
        <div className="simple-grid">
          <div className="simple-left">
            {loading ? (
              <LoadingSpinner text="Yükleniyor..." />
            ) : error ? (
              <p className="simple-error">{error}</p>
            ) : services && services.length > 0 ? (
              <motion.div
                className="simple-card-wrap"
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              >
                <div className="simple-card">
                  <div className="simple-card-media">
                    <img
                      src={cloudinaryImage(services[0].imageUrl, 800) || '/images/default-service.jpg'}
                      alt={services[0].title}
                      className="simple-card-image"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="simple-card-body">
                    <h3 className="simple-card-title">{services[0].title}</h3>
                    <p className="simple-card-excerpt">
                      {services[0].description && typeof services[0].description === 'string'
                        ? services[0].description.substring(0, 180) + '...'
                        : 'Açıklama mevcut değil.'}
                    </p>
                    <Link to={`/services/${services[0].slug || services[0].id}`} className="simple-card-cta">
                      Details <FiArrowRight className="cta-icon" />
                    </Link>
                  </div>
                </div>
              </motion.div>
            ) : (
              <p className="simple-empty">There are no services to be shown yet.</p>
            )}
          </div>

          <div className="simple-right">
            <motion.div
              className="count-block"
              initial={{ opacity: 0, scale: 0.98 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <motion.div
                className="count-label"
                initial={{ opacity: 0, scale: 0.8, rotate: -8 }}
                whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                transition={{ duration: 0.7, ease: [0.22, 0.9, 0.32, 1] }}
                viewport={{ once: true }}
              >
                Number of Projects
              </motion.div>
              <CountUp
                from={1000}
                to={Array.isArray(services) ? services.length : 0}
                duration={1.6}
                separator=","
                className="count-number"
              />

              <div className="starborder-btn-wrap">
                <Link to="/services" style={{ textDecoration: 'none' }}>
                  <StarBorder
                    as="span"
                    className="starborder-btn"
                    color="blue"
                    speed="2s"
                  >
                    See All Projects
                  </StarBorder>
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;